import React from 'react'

import { compose, withHandlers } from 'recompose'
import styled from 'styled-components'

import withClickOutside from 'components/HOCs/WithClickOutside'

import { TestIDs } from '../../test/utils/testIds'

interface Props {
  onClickOutside: () => void
  onSelect: (suggestion: google.maps.places.AutocompletePrediction) => void
  suggestions: google.maps.places.AutocompletePrediction[]
}

interface HandlerProps {
  handleSuggestionClick: (event: React.MouseEvent) => void
}

type MergedProps = Props & HandlerProps

const enhance = compose<MergedProps, Props>(
  withHandlers<MergedProps, HandlerProps>({
    handleSuggestionClick: ({ onSelect, suggestions }) => ({ target }: React.MouseEvent) => {
      onSelect(suggestions[(target as HTMLElement).dataset.index])
    },
  }),
  withClickOutside(({ onClickOutside }) => {
    onClickOutside(false)
  }),
)

const List = styled.ul`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.13);
  left: 0;
  list-style: none;
  margin: -20px 0 0;
  max-height: 313px;
  overflow: scroll;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: 9999;

  li:not(:last-child) {
    border-bottom: 1px solid #f5f5f5;
  }
`

const ListItem = styled.li`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 60px;
  padding: 0 20px;
  transition: opacity 200ms;
  font-size: 14px;

  &:hover {
    opacity: 0.7;
  }
`

const AutoCompleteList: React.ComponentClass<Props> = enhance(
  ({ handleSuggestionClick, suggestions }) => (
    <List data-testid={TestIDs.AUTOCOMPLETE_ADDRESS.LIST}>
      {suggestions.map((suggestion, index) => (
        <ListItem
          key={suggestion.place_id}
          onClick={handleSuggestionClick}
          data-index={index}
          tabIndex={0}
          role="listitem"
          data-testid={`${TestIDs.AUTOCOMPLETE_ADDRESS.LIST_ITEM}_${suggestion.place_id}`}
        >
          {suggestion.description}
        </ListItem>
      ))}
    </List>
  ),
)

export default AutoCompleteList
